import { useCallback } from 'react';
import { CatalogItemListFilter } from '@common/model/catalog/item/list.filter';
import { difference } from 'lodash';
import { useTrackEvent } from 'src/shared/tracking';
import { FormAvailableOnlyFieldName } from 'src/entities/catalog/ui/availableOnly/model';
import { CatalogEvents } from 'src/features/catalog';

export const useTrackFilterEvents = () => {
  const track = useTrackEvent();
  return useCallback(
    (filter: CatalogItemListFilter = {}, prevFilter: CatalogItemListFilter = {}) => {
      const addedKeys = difference(Object.keys(filter), Object.keys(prevFilter));
      for (const filterKey of addedKeys) {
        switch (filterKey) {
          case 'priceMax':
            track(CatalogEvents.FilterPriceChange());
            break;
          case FormAvailableOnlyFieldName.Date:
            track(CatalogEvents.FilterShowAvailable());
            track(CatalogEvents.FilterDateChange());
            break;
          case FormAvailableOnlyFieldName.Start:
          case FormAvailableOnlyFieldName.End:
            track(CatalogEvents.FilterTimeChange());
            break;
          default:
        }
      }
    },
    [track],
  );
};
